export const ticketNumberRegexes: { [key: number]: string[] } = {
  202: ["/^\\d{2,3}-\\d{7,8}$/"], // Bedsonline
  586: ["/^\\d{14}$/"], // Expedia,
  701: ["/^014\\d{10}$/", "/^[A-Za-z0-9]{6}$/"], // Air Canada
  101: ["/^\\d{8}$/"], // Air Canada Vacation
  115: ["/^\\d{6,9}$/"], // Sunwing
  941: ["/^[A-Za-z0-9]+$/"], // WESTJET VACATIONS/SUNWING - QUEBEC
  7187: ["/^\\d{6,9}$/"], // TravelBrands
  806: ["/^[A-Za-z0-9]+$/"], // INTAIR (TravelBrands)
  401: ["/^[A-Za-z0-9]+$/"], // ENCORE CRUISES (TravelBrands)
  125: ["/^[A-Za-z0-9]+$/"], // HOLIDAY HOUSE (TravelBrands)
  120: ["/^[A-Za-z0-9]+$/"], // BOOMERANG (TravelBrands)
  107: ["/^[A-Za-z0-9]+$/"], // SUNQUEST VACATIONS (TravelBrands)
  104: ["/^[A-Za-z0-9]+$/"], // EXOTIK TOURS (TravelBrands)
  28: ["/^[A-Za-z0-9]+$/"] // TRAVEL GENIE (TravelBrands)
};
